import { useTranslation } from 'react-i18next'
import { Microscope, GraduationCap, Hammer, Users, type LucideIcon } from 'lucide-react'
import { Reveal } from './reveal'

interface PersonaItem {
  readonly icon: LucideIcon
  readonly key: string
}

const PERSONAS: readonly PersonaItem[] = [
  { icon: Microscope, key: 'researcher' },
  { icon: GraduationCap, key: 'student' },
  { icon: Hammer, key: 'builder' },
  { icon: Users, key: 'team' },
]

export function TargetUsers() {
  const { t } = useTranslation()

  return (
    <section className="mx-auto max-w-6xl px-6 py-24">
      <Reveal className="text-center">
        <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
          {t('landing.users.title')}
        </h2>
      </Reveal>

      <Reveal stagger className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {PERSONAS.map(({ icon: Icon, key }) => (
          <div
            key={key}
            className="glass-card glass-hover group relative overflow-hidden rounded-2xl p-6"
          >
            <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-[color-mix(in_oklch,var(--foreground)_10%,transparent)] bg-[color-mix(in_oklch,var(--foreground)_5%,transparent)] text-foreground transition-transform duration-300 group-hover:scale-110">
              <Icon className="h-5 w-5" />
            </div>
            <h3 className="mt-5 text-lg font-semibold text-foreground">
              {t(`landing.users.${key}.title`)}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              {t(`landing.users.${key}.body`)}
            </p>
          </div>
        ))}
      </Reveal>
    </section>
  )
}
